"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._getDashboardTime = exports._getDashboardBrand = exports._getDashboardContractor = void 0;
const axios_1 = __importDefault(require("axios"));
const error_response_1 = require("utils/error-response");
const get_from_localstorage_1 = require("utils/get-from-localstorage");
const _getDashboardContractor = (params) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const url = String(process.env.API_ENDPOINT) + '/transaction/dashboard-silo/contractor';
        const config = {
            params: params,
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
            }
        };
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return {
            isError,
            errorCode,
            errorMessage,
            data: {
                dataCard: [],
                dataSilo: [],
                dataPerformance: []
            }
        };
    }
});
exports._getDashboardContractor = _getDashboardContractor;
const _getDashboardBrand = (params) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const url = String(process.env.API_ENDPOINT) + '/transaction/dashboard-silo/brand';
        const config = {
            params: params,
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
            }
        };
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return {
            isError,
            errorCode,
            errorMessage,
            data: {
                dataCard: [],
                dataPerformance: [],
            }
        };
    }
});
exports._getDashboardBrand = _getDashboardBrand;
const _getDashboardTime = (params) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const url = String(process.env.API_ENDPOINT) + '/transaction/dashboard-silo/time';
        const config = {
            params: params,
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
            }
        };
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return {
            isError,
            errorCode,
            errorMessage,
            data: {
                dataLead: [],
                dataQueue: [],
                dataLeadSilo: [],
                dataQueueSilo: [],
            }
        };
    }
});
exports._getDashboardTime = _getDashboardTime;
